import { useState } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import Security from './components/Security';
import HowItWorks from './components/HowItWorks';
import Download from './components/Download';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Features />
      <Security />
      <HowItWorks />
      <Download />
      <Contact />
      <Footer />
    </div>
  );
}
